
import React from "react";

const AdminDashboard = () => {

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                        <h4 className="mb-sm-0">Dashboard</h4>
                        {/* <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript: void(0);">Dashboards</a>
                                </li>
                                <li className="breadcrumb-item active">CRM</li>
                            </ol>
                        </div> */}
                    </div>
                </div>
            </div>
            {/* end page title */}
            
         
            <div className="row">
                <div className="col-xl-7">
                    <div className="card">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Deals Status</h4>
                            <div className="flex-shrink-0">
                                <div className="dropdown card-header-dropdown">
                                    <a
                                        className="text-reset dropdown-btn"
                                        href="javascript:void(0)"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <span className="text-muted">
                                            02 Nov 2021 to 31 Dec 2021
                                            <i className="mdi mdi-chevron-down ms-1" />
                                        </span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Today
                                        </a>
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Last Week
                                        </a>
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Last Month
                                        </a>
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Current Year
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end card header */}
                        <div className="card-body">
                            <div className="table-responsive table-card">
                                <table className="table table-borderless table-hover table-nowrap align-middle mb-0">
                                    <thead className="table-light">
                                        <tr className="text-muted">
                                            <th scope="col">Name</th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Last Contacted
                                            </th>
                                            <th scope="col">Sales Representative</th>
                                            <th scope="col" style={{ width: "16%" }}>
                                                Status
                                            </th>
                                            <th scope="col" style={{ width: "12%" }}>
                                                Deal Value
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* <tr>
                                            <td>Absternet LLC</td>
                                            <td>Sep 20, 2021</td>
                                            <td>
                                                <img
                                                    src="assets/images/users/avatar-1.jpg"
                                                    alt=""
                                                    className="avatar-xs rounded-circle me-2 material-shadow"
                                                />
                                                <a
                                                    href="#javascript: void(0);"
                                                    className="text-body fw-medium"
                                                >
                                                    Donald Risher
                                                </a>
                                            </td>
                                            <td>
                                                <span className="badge bg-success-subtle text-success p-2">
                                                    Deal Won
                                                </span>
                                            </td>
                                            <td>
                                                <div className="text-nowrap">$100.1K</div>
                                            </td>
                                        </tr>
                                         */}
                                    </tbody>
                                    {/* end tbody */}
                                </table>
                                {/* end table */}
                            </div>
                            {/* end table responsive */}
                        </div>
                        {/* end card body */}
                    </div>
                    {/* end card */}
                </div>
                {/* end col */}
                <div className="col-xl-5">
                    <div className="card card-height-100">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">My Tasks</h4>
                            <div className="flex-shrink-0">
                                <div className="dropdown card-header-dropdown">
                                    <a
                                        className="text-reset dropdown-btn"
                                        href="javascript:void(0)"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <span className="text-muted">
                                            <i className="ri-settings-4-line align-bottom me-1 fs-15" />
                                            Settings
                                        </span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Edit
                                        </a>
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Remove
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end card header */}
                        <div className="card-body p-0">
                            <div className="align-items-center p-3 justify-content-between d-flex">
                            
                            </div>
                            {/* end card header */}
                            <div data-simplebar="" style={{ maxHeight: 219 }}>
                                <ul className="list-group list-group-flush border-dashed px-3">
                                    {/* <li className="list-group-item ps-0">
                                        <div className="d-flex align-items-start">
                                            <div className="form-check ps-0 flex-sharink-0">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-0"
                                                    id="task_one"
                                                />
                                            </div>
                                            <div className="flex-grow-1">
                                                <label
                                                    className="form-check-label mb-0 ps-2"
                                                    htmlFor="task_one"
                                                >
                                                    Review and make sure nothing slips through cracks
                                                </label>
                                            </div>
                                            <div className="flex-shrink-0 ms-2">
                                                <p className="text-muted fs-12 mb-0">15 Sep, 2021</p>
                                            </div>
                                        </div>
                                    </li>
                                     */}
                                </ul>
                                {/* end ul */}
                            </div>
                            
                        </div>
                        {/* end card body */}
                    </div>
                    {/* end card */}
                </div>
                {/* end col */}
            </div>
            {/* end row */}
            <div className="row">
                <div className="col-xxl-5">
                    <div className="card">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Upcoming Activities</h4>
                            <div className="flex-shrink-0">
                                <div className="dropdown card-header-dropdown">
                                    <a
                                        className="text-reset dropdown-btn"
                                        href="javascript:void(0)"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <span className="text-muted fs-18">
                                            <i className="mdi mdi-dots-vertical" />
                                        </span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Edit
                                        </a>
                                        <a className="dropdown-item" href="javascript:void(0)">
                                            Remove
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* end card header */}
                        <div className="card-body pt-0">
                            <ul className="list-group list-group-flush border-dashed">
                               
                            </ul>
                        </div>
                        {/* end card body */}
                    </div>
                    {/* end card */}
                </div>
                {/* end col */}
                <div className="col-xxl-7">
                    <div className="card card-height-100">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Closing Deals</h4>
                            <div className="flex-shrink-0">
                                <select
                                    className="form-select form-select-sm"
                                    aria-label=".form-select-sm example"
                                >
                                    <option selected="">Closed Deals</option>
                                    <option value={1}>Active Deals</option>
                                    <option value={2}>Paused Deals</option>
                                    <option value={3}>Canceled Deals</option>
                                </select>
                            </div>
                        </div>
                        {/* end card header */}
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-nowrap align-middle mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col" style={{ width: "30%" }}>
                                                Deal Name
                                            </th>
                                            <th scope="col" style={{ width: "30%" }}>
                                                Sales Rep
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Amount
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Close Date
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                    {/* end tbody */}
                                </table>
                                {/* end table */}
                            </div>
                            {/* end table responsive */}
                        </div>
                        {/* end card body */}
                    </div>
                    {/* end card */}
                </div>
                {/* end col */}
            </div>
            {/* end row */}
        </>

    );
}

export default AdminDashboard;
